module.exports = __webpack_public_path__ + "static/img/img-login-enpty.ec06968.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/img-login-enpty.png
// module id = xsVd
// module chunks = 1